function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/editor/editorui
 */

/* globals console */
import ComponentFactory from '@ckeditor/ckeditor5-ui/src/componentfactory';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * A class providing the minimal interface that is required to successfully bootstrap any editor UI.
 *
 * @mixes module:utils/emittermixin~EmitterMixin
 */

var EditorUI = /*#__PURE__*/function () {
  /**
   * Creates an instance of the editor UI class.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   */
  function EditorUI(editor) {
    var _this = this;

    _classCallCheck(this, EditorUI);

    /**
     * The editor that the UI belongs to.
     *
     * @readonly
     * @member {module:core/editor/editor~Editor} #editor
     */
    this.editor = editor;
    /**
     * An instance of the {@link module:ui/componentfactory~ComponentFactory}, a registry used by plugins
     * to register factories of specific UI components.
     *
     * @readonly
     * @member {module:ui/componentfactory~ComponentFactory} #componentFactory
     */

    this.componentFactory = new ComponentFactory(editor);
    /**
     * Stores the information about the editor UI focus and propagates it so various plugins and components
     * are unified as a focus group.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker} #focusTracker
     */

    this.focusTracker = new FocusTracker();
    /**
     * Stores all editable elements used by the editor instance.
     *
     * @private
     * @member {Map.<String,HTMLElement>}
     */

    this._editableElementsMap = new Map(); // Informs UI components that should be refreshed after layout change.

    this.listenTo(editor.editing.view.document, 'layoutChanged', function () {
      return _this.update();
    });
  }
  /**
   * The main (outermost) DOM element of the editor UI.
   *
   * For example, in {@link module:editor-classic/classiceditor~ClassicEditor} it is a `<div>` which
   * wraps the editable element and the toolbar. In {@link module:editor-inline/inlineeditor~InlineEditor}
   * it is the editable element itself (as there is no other wrapper). However, in
   * {@link module:editor-decoupled/decouplededitor~DecoupledEditor} it is set to `null` because this editor does not
   * come with a single "main" HTML element (its editable element and toolbar are separate).
   *
   * This property can be understood as a shorthand for retrieving the element that a specific editor integration
   * considers to be its main DOM element.
   *
   * @readonly
   * @member {HTMLElement|null} #element
   */


  _createClass(EditorUI, [{
    key: "element",
    get: function get() {
      return null;
    }
    /**
     * Fires the {@link module:core/editor/editorui~EditorUI#event:update `update`} event.
     *
     * This method should be called when the editor UI (e.g. positions of its balloons) needs to be updated due to
     * some environmental change which CKEditor 5 is not aware of (e.g. resize of a container in which it is used).
     */

  }, {
    key: "update",
    value: function update() {
      this.fire('update');
    }
    /**
     * Destroys the UI.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
      this.focusTracker.destroy(); // Clean–up the references to the CKEditor instance stored in the native editable DOM elements.

      var _iterator = _createForOfIteratorHelper(this._editableElementsMap.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var domElement = _step.value;
          domElement.ckeditorInstance = null;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._editableElementsMap = new Map();
    }
    /**
     * Store the native DOM editable element used by the editor under
     * a unique name.
     *
     * @param {String} rootName The unique name of the editable element.
     * @param {HTMLElement} domElement The native DOM editable element.
     */

  }, {
    key: "setEditableElement",
    value: function setEditableElement(rootName, domElement) {
      this._editableElementsMap.set(rootName, domElement); // Put a reference to the CKEditor instance in the editable native DOM element.
      // It helps 3rd–party software (browser extensions, other libraries) access and recognize
      // CKEditor 5 instances (editing roots) and use their API (there is no global editor
      // instance registry).


      if (!domElement.ckeditorInstance) {
        domElement.ckeditorInstance = this.editor;
      }
    }
    /**
     * Returns the editable editor element with the given name or null if editable does not exist.
     *
     * @param {String} [rootName=main] The editable name.
     * @returns {HTMLElement|undefined}
     */

  }, {
    key: "getEditableElement",
    value: function getEditableElement() {
      var rootName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
      return this._editableElementsMap.get(rootName);
    }
    /**
     * Returns array of names of all editor editable elements.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getEditableElementsNames",
    value: function getEditableElementsNames() {
      return this._editableElementsMap.keys();
    }
    /**
     * Stores all editable elements used by the editor instance.
     *
     * @protected
     * @deprecated
     * @member {Map.<String,HTMLElement>}
     */

  }, {
    key: "_editableElements",
    get: function get() {
      /**
       * The {@link module:core/editor/editorui~EditorUI#_editableElements `EditorUI#_editableElements`} property has been
       * deprecated and will be removed in the near future. Please use {@link #setEditableElement `setEditableElement()`} and
       * {@link #getEditableElement `getEditableElement()`} methods instead.
       *
       * @error editor-ui-deprecated-editable-elements
       * @param {module:core/editor/editorui~EditorUI} editorUI Editor UI instance the deprecated property belongs to.
       */
      console.warn('editor-ui-deprecated-editable-elements: ' + 'The EditorUI#_editableElements property has been deprecated and will be removed in the near future.', {
        editorUI: this
      });
      return this._editableElementsMap;
    }
    /**
     * Fired when the editor UI is ready.
     *
     * Fired before {@link module:engine/controller/datacontroller~DataController#event:ready}.
     *
     * @event ready
     */

    /**
     * Fired whenever the UI (all related components) should be refreshed.
     *
     * **Note:**: The event is fired after each {@link module:engine/view/document~Document#event:layoutChanged}.
     * It can also be fired manually via the {@link module:core/editor/editorui~EditorUI#update} method.
     *
     * @event update
     */

  }]);

  return EditorUI;
}();

export { EditorUI as default };
mix(EditorUI, EmitterMixin);